import { Observable } from 'rxjs';

import { Group, GroupOperationError } from '@shure/cloud/shared/models/devices';
import { RequestResponse } from '@shure/shared/angular/data-access/system-api/models';

import {
	AddDevicesToGroupInput,
	AddSpacesToGroupInput,
	CreateGroupInput,
	DeleteGroupInput,
	MoveGroupInput,
	UngroupDevicesInput,
	UngroupSpacesInput,
	RenameGroupInput
} from '../api-instance-sys-api/graphql/generated/cloud-sys-api';

export type CreateGroupApiInput = CreateGroupInput;
export type DeleteGroupApiInput = DeleteGroupInput;
export type RenameGroupApiInput = RenameGroupInput;
export type MoveGroupApiInput = MoveGroupInput;
export type AddDevicesToGroupApiInput = AddDevicesToGroupInput;
export type UngroupDevicesApiInput = UngroupDevicesInput;
export type AddSpacesToGroupApiInput = AddSpacesToGroupInput;
export type UngroupSpacesApiInput = UngroupSpacesInput;

export type GroupMemberOperationResponse = {
	results: {
		id: string;
		error?: GroupOperationError;
	}[];
} & RequestResponse<GroupOperationError>;

export abstract class GroupsApiService {
	public abstract groupsLoadingComplete$: Observable<boolean>;
	public abstract groupAdded$: Observable<Group>;
	public abstract groupRemoved$: Observable<string>;
	public abstract groupSnapshot$: Observable<Group>;
	public abstract suspended$: Observable<void>;

	public abstract getCachedGroups$(): Observable<Group[]>;
	public abstract createGroup(input: CreateGroupApiInput): Observable<RequestResponse<GroupOperationError>>;
	public abstract deleteGroup(input: DeleteGroupApiInput): Observable<RequestResponse<GroupOperationError>>;
	public abstract renameGroup(input: RenameGroupApiInput): Observable<RequestResponse<GroupOperationError>>;
	public abstract moveGroup(input: MoveGroupApiInput): Observable<RequestResponse<GroupOperationError>>;
	public abstract addDevicesToGroup(input: AddDevicesToGroupApiInput): Observable<GroupMemberOperationResponse>;
	public abstract ungroupDevices(input: UngroupDevicesApiInput): Observable<GroupMemberOperationResponse>;
	public abstract addSpacesToGroup(input: AddSpacesToGroupApiInput): Observable<GroupMemberOperationResponse>;
	public abstract ungroupSpaces(input: UngroupSpacesApiInput): Observable<GroupMemberOperationResponse>;
}
